module.exports = __webpack_public_path__ + "static/img/服务流程.09b0fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/T载体克隆/服务流程.png
// module id = 6ben
// module chunks = 1